import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import QuoteButton from './components/QuoteButton';
import Home from './pages/Home';
import About from './pages/About';
import Furniture from './pages/Furniture';
import Export from './pages/Export';
import Manufacturing from './pages/Manufacturing';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import GlobalSourcing from './pages/GlobalSourcing';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/furniture" element={<Furniture />} />
            <Route path="/export" element={<Export />} />
            <Route path="/manufacturing" element={<Manufacturing />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/global-sourcing" element={<GlobalSourcing />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
        <QuoteButton />
        <Toaster position="top-right" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
